module.exports = __webpack_public_path__ + "img/28292A_D3DAE5_A3ACB8_818183-256px.678805f4.png";